import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NB_AUTH_OPTIONS } from '../../auth.options';
import { getDeepFromObject } from '../../helpers';
import { ApiService } from '../../../services/api.service';
import { URLConfig } from '../../../../configs/url-config';

@Component({
  selector: 'nb-reset-password-page',
  styleUrls: ['./reset-password.component.scss'],
  templateUrl: './reset-password.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NbResetPasswordComponent {

  resetForm!: FormGroup;
  submitted = false;
  errors: string[] = [];
  messages: string[] = [];

  email: string | null = "";

  constructor(
    private fb: FormBuilder,
    private _apiService: ApiService,
    @Inject(NB_AUTH_OPTIONS) protected options = {},
    protected cd: ChangeDetectorRef,
    protected router: Router
  ) {
    this.email = this._apiService.getValueLocalEmail();

    this.resetForm = this.fb.group(
      {
        code: ['', Validators.required],
        newPassword: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(30)]],
        confirmPassword: ['', Validators.required],
      },
      { validators: this.passwordMatchValidator }
    );
  }

  get f() {
    return this.resetForm.controls;
  }

  passwordMatchValidator(form: FormGroup) {
    const pass = form.get('newPassword')?.value;
    const confirm = form.get('confirmPassword')?.value;
    return pass === confirm ? null : { passwordMismatch: true };
  }

resetPass() {
  if (this.resetForm.invalid) return;

  this.submitted = true;
  this.errors = [];
  this.messages = [];

  const email = encodeURIComponent(this.email);
  const code = encodeURIComponent(this.resetForm.value.code);
  const password = encodeURIComponent(this.resetForm.value.newPassword);

  const url = `${URLConfig.changepassword}?email=${email}&code=${code}&password=${password}`;

  this._apiService.post(url, {}).subscribe({
    next: () => {
      this._apiService.success('Password changed successfully!');
      this.messages = ['Password updated successfully'];

      setTimeout(() => {
        this.router.navigate(['/auth/login']);
      }, 1000);

      this.cd.detectChanges();
    },
    error: () => {
      this.submitted = false;
      this.errors = ['Invalid OTP or password change failed'];
      this.cd.detectChanges();
    }
  });
}

}
